import React, { useState, useRef } from "react";
import { Helmet } from "react-helmet";
import Header from "../components/Header";

const faqs = [
  {
    id: 1,
    header: "طلایی شو چیست و چطور کار میکند؟",
    text: `
طلایی شو پلتفرم آنلاین خرید و فروش و نگهداری طلا و نقره است. شما می توانید با توجه به بودجه تان طلا و نقره بخرید، بفروشید و سود کنید.`,
  },
  {
    id: 2,
    header: "چطور به طلایی شو اعتماد کنم؟",
    text: `طلایی شو دارای پروانه کسب سامانه معاملات آنلاین طلای آب شده و مصنوعات طلا و نقره  و جواهر از دبیرخانه هیأت عالی نظارت بر سازمان های صنفی کشور و مجوز رسمی کسب و کارهای اینترنتی اینماد می باشد`,
  },
  {
    id: 3,
    header: "چطور در طلایی شو ثبت  نام کنم؟",
    text: `ثبت نام در طلایی شو فقط با کد ملی انجام می شود و هیچ نیازی به ویدیوی احراز هویت، ارسال عکس شخصی یا تعهدنامه ندارد. در کمتر از یک دقیقه  در طلایی شو ثبت نام کنید.`,
  },
  {
    id: 4,
    header: "آیا شمش طلا و نقره  برای سرمایه گذاری مناسب است؟",
    text: `از دیرباز طلا و نقره مطمئن ترین راه برای سرمایه گذاری بوده است چون مشکلاتی مانند «حباب قیمتی» و «اجرت ساخت» ندارد و همواره نسبت به تورم مقاوم بوده است.`,
  },
  {
    id: 5,
    header: "چطور شمش طلا و نقره  را خرید و فروش کنم؟",
    text: `به محض ثبت نام در طلایی شو، می توانید و خرید و فروش طلا و نقره  را شروع کنید. خرید و فروش در هر لحظه از شبانه روز امکان پذیر است.`,
  },
  {
    id: 6,
    header: "کارمزد طلایی شو چقدر است؟",
    text: `کارمزد خرید و فروش در صفحه بازار طلایی شو با سایر کاربران و قیمت پیشنهادی 0.5 درصد است و مبلغ کارمزد خرید و فروش مستقیم طلا با طلایی شو از طریق صفحه معامله کمتر از صد گرم ١.٥ درصد، کمتر از پانصد گرم ١ درصد بیشتر از یک کیلو گرم ٠.٥ درصد است و کارمزد خرید و فروش نقره مستقیم با طلایی شو از صفحه معامله کمتر از یک کیلو گرم ۱.۵ درصد و بیشتر از یک کیلوگرم ۱ درصد است.
    `,
  },
  {
    id: 7,
    header: "عیار شمش طلا و نقره  در طلایی شو چقدر است؟",
    text: `در طلایی شو میتوانید طلای ١٨ عیار و طلای ٢٤ عیار ٩٩٩.٩ و نقره ۹۲۵ معامله کنید.`,
  },
  {
    id: 8,
    header: "آیا امکان خرید حضوری از طلایی شو وجود دارد؟",
    text: `خدمات خرید و فروش طلا و نقره در طلایی شو به صورت آنلاین و حضوری انجام می شود.`,
  },
  {
    id: 9,
    header: "چه سودی برای من دارد که از دوستانم دعوت کنم؟",
    text: `در طرح جدید دعوت دوستان طلایی شو ، شما میتوانید سهام دیجیتال زرینو از طلایی شو خریداری نمائید و با دعوت از دوستانتان و افزایش تعداد کاربران و تعداد معاملات ارزش سهامتون به تناسب افزایش پیدا می کند.`,
  },
  {
    id: 10,
    header: "زرینو چیست؟",
    text: `با خرید و معرفی سهام دیجیتال زرینو، محصولی از پلتفرم طلایی شو، به دنیای جدید سرمایه‌گذاری در دارایی‌های پشتوانه‌دار وارد شوید!
زرینو یک سهام دیجیتال با پشتوانه واقعی از طلا و نقره خالص است که ارزش آن به نسبت ۴۰٪ طلا، ۲۰٪ نقره، ۲۰٪ تعداد کاربران طلایی شو و ۲۰٪ میزان معاملات این پلتفرم محاسبه می‌شود.
با خرید و معرفی زرینو، نه تنها از افزایش قیمت طلا و نقره سود می‌برید، بلکه با رشد اکوسیستم طلایی شو (افزایش کاربران و معاملات) ارزش دارایی دیجیتال شما به شکل هوشمندانه‌ای افزایش پیدا می‌کند.
در شرایطی که بازارهای جهانی طلا و نقره دچار نوسان‌اند، زرینو با بهره‌گیری از چندین شاخص پایدار، ریسک‌های ناشی از افت قیمت را به حداقل می‌رساند.
سرمایه‌گذاری در زرینو، یک انتخاب هوشمندانه‌ است:\n
✅ امنیت دارایی دیجیتال\n
✅ نقدشوندگی بالا\n
✅ رشد چندجانبه ارزش\n
✅ مشارکت در توسعه طلایی شو پلتفرم فلزات گرانبها\n
همین امروز زرینو بخرید و آینده مالی خود را هوشمندانه بسازید!`,
  },
  {
    id: 11,
    header:
      "آیا قیمت طلا و نقره  در بازار طلایی شو کمتر از سایر فروشندگان است؟",
    text: `بله، به علت عرضه ی بالا و وجود بازار رقابتی در طلایی شو، قیمت طلا و نقره  پایین تر از سایر فروشندگان است.`,
  },
  {
    id: 12,
    header: "آیا سرمایه گذاری در طلا و نقره  نیاز به یادگیری دارد؟",
    text: `معامله و سرمایه گذاری در طلا و نقره  بسیار راحت است. کافی است بخش راهنمای استفاده را بخوانید یا ویدیوی آموزشی را ببینید. `,
  },
  {
    id: 13,
    header: "چگونه شمش طلا و نقره ی خریداری شده را تحویل بگیرم؟",
    text: `وارد بخش صندوق طلا و نقره  شوید، سپس شمش طلا یا نقره ی درخواستی را انتخاب کنید، بعد از ثبت درخواست و پرداخت حق ضرب ظرف ۳ روز کاری با مدارک شناسایی معتبر به ۴ نمایندگی طلایی شو در تهران، مشهد، اصفهان، و مازندران مراجعه کرده و شمش طلا و نقره  را تحویل بگیرید.`,
  },
  {
    id: 14,
    header: "طلاو نقره ی خریداری شده را ارسال هم میکنید؟",
    text: `بله شما پس از ثبت درخواست تحویل شمش طلا و نقره  در صفحه صندوق طلا و نقرتون در طلایی شو و پرداخت حق ضرب و هزینه پست از طریق افرونه چت پشتیبانی سایت و یا ایمیل میتوانید آدرس و کد پستی خود را همراه با تصویر کارت ملی ارسال کنید و ظرف ۷ روز کاری پس از تایید درخواست طلا و نقره  برای شما از طریق پست ارسال میگردد.`,
  },
  {
    id: 15,
    header: "آیا امکان خرید اعتباری و قسطی دارید؟",
    text: `خرید قسطی طلا و نقره  همراه با نرخ ۲۵ الی ۳۰ درصدی مقرون به صرفه نیست و میتوانید با خرید طلا و نقره  بصورت ماهانه از طلایی شو با کمترین کارمزد بیشترین سود را به نسبت خرید قسطی ببرید.`,
  },
];

const AccordionItem = (props) => {
  const contentEl = useRef();
  const { handleToggle, active, faq } = props;
  const { header, id, text } = faq;

  return (
    <>
      <div
        className={`rc-accordion-card ${active === id ? "show" : ""} bg-custom`}
      >
        <div className="rc-accordion-header">
          <div
            className={`rc-accordion-toggle p-3 ${
              active === id ? "active" : ""
            }`}
            onClick={() => handleToggle(id)}
          >
            <h1 className="rc-accordion-title">{header}</h1>
            <i className="fa fa-chevron-down rc-accordion-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-chevron-down"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                />
              </svg>
            </i>
          </div>
        </div>
        <div
          ref={contentEl}
          className={`rc-collapse ${active === id ? "show" : ""}`}
          style={
            active === id
              ? { height: contentEl.current.scrollHeight }
              : { height: "0px" }
          }
        >
          <div className="rc-accordion-body">
            <h2 className="mb-0">{text}</h2>
          </div>
        </div>
      </div>
    </>
  );
};

const Faq = () => {
  const [active, setActive] = useState(null);

  const handleToggle = (index) => {
    if (active === index) {
      setActive(null);
    } else {
      setActive(index);
    }
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org", "@type": "FAQPage", "mainEntity": [{ "@type": "Question", "name": "طلایی شو چیست و چطور کار می کند؟", "acceptedAnswer": { "@type": "Answer", "text": "ه محض دریافت هدیه (۵ سُوت طلا) کافی است تنها یک گرم طلا و نقره  خرید کنید تا هدیه خود را در صندوق طلا و نقره  یا حساب بانکی خود دریافت کنید" } },{ "@type": "Question", "name": "آیا امکان خرید اعتباری و قسطی دارید؟", "acceptedAnswer": { "@type": "Answer", "text": "خرید قسطی طلا و نقره  همراه با نرخ ۲۵ الی ۳۰ درصدی مقرون به صرفه نیست و میتوانید با خرید طلا و نقره  بصورت ماهانه از طلایی شو با کمترین کارمزد بیشترین سود را به نسبت خرید قسطی ببرید." } },{ "@type": "Question", "name": "چطور به طلایی شو اعتماد کنم؟", "acceptedAnswer": { "@type": "Answer", "text": "طلایی شو دارای پروانه کسب سامانه معاملات آنلاین طلای آب شده و مصنوعات طلا و نقره  و جواهر از دبیرخانه هیأت عالی نظارت بر سازمان های صنفی کشور و مجوز رسمی کسب و کارهای اینترنتی اینماد می باشد" } },{ "@type": "Question", "name": "چطور در طلایی شو ثبت نام کنم؟", "acceptedAnswer": { "@type": "Answer", "text": "ثبت نام در طلایی شو فقط با کد ملی انجام می شود و هیچ نیازی به ویدیوی احراز هویت، ارسال عکس شخصی یا تعهدنامه ندارد. در کمتر از یک دقیقه در طلایی شو ثبت نام کنید." } },{ "@type": "Question", "name": "آیا شمش طلا و نقره  برای سرمایه گذاری مناسب است؟", "acceptedAnswer": { "@type": "Answer", "text": "از دیرباز طلا و نقره  مطمئن ترین راه برای سرمایه گذاری بوده است چون مشکلاتی مانند «حباب قیمتی» و «اجرت ساخت» ندارد و همواره نسبت به تورم مقاوم بوده است." } },{ "@type": "Question", "name": "چطور شمش طلا و نقره  را خرید و فروش کنم؟", "acceptedAnswer": { "@type": "Answer", "text": "به محض ثبت نام در طلایی شو، می  توانید و خرید و فروش طلا و نقره  را شروع کنید. خرید و فروش در هر لحظه از شبانه روز امکان  پذیر است." } },{ "@type": "Question", "name": "کارمزد طلایی شو چقدر است؟", "acceptedAnswer": { "@type": "Answer", "text": "رمزد خرید و فروش مستقیم از طلایی شو ۵٪ و کارمزد خرید و فروش در بخش بازار ۳٪ است. طلای شو برای نگهداری و بیمه طلا و نقره  به طور سالانه ۰/۱۲٪ کارمزد می گیرد. " } },{ "@type": "Question", "name": "عیار طلا و نقره  در طلایی شو چقدر است؟", "acceptedAnswer": { "@type": "Answer", "text": "تمام طلاهای قابل  معامله در طلایی  شو، ۲۴ عیار و استاندارد هستند." } },{ "@type": "Question", "name": "آیا امکان خرید حضوری طلا و نقره  از طلایی شو وجود دارد؟", "acceptedAnswer": { "@type": "Answer", "text": "خدمات خرید و فروش طلا و نقره در طلایی شو به صورت آنلاین و حضوری انجام می شود. " } },{ "@type": "Question", "name": "چه سودی برای من دارد که از دوستانم دعوت کنم؟", "acceptedAnswer": { "@type": "Answer", "text": "در طرح جدید دعوت دوستان طلایی شو ، شما میتوانید سهام دیجیتال زرینو از طلایی شو خریداری نمائید و با دعوت از دوستانتان و افزایش تعداد کاربران و تعداد معاملات ارزش سهامتون به تناسب افزایش پیدا می کند." } },{ "@type": "Question", "name": "زرینو چیست؟", "acceptedAnswer": { "@type": "Answer", "text": "با خرید و معرفی سهام دیجیتال زرینو، محصولی از پلتفرم طلایی شو، به دنیای جدید سرمایه‌گذاری در دارایی‌های پشتوانه‌دار وارد شوید! زرینو یک سهام دیجیتال با پشتوانه واقعی از طلا و نقره خالص است که ارزش آن به نسبت ۴۰٪ طلا، ۲۰٪ نقره، ۲۰٪ تعداد کاربران طلایی شو و ۲۰٪ میزان معاملات این پلتفرم محاسبه می‌شود. با خرید و معرفی زرینو، نه تنها از افزایش قیمت طلا و نقره سود می‌برید، بلکه با رشد اکوسیستم طلایی شو (افزایش کاربران و معاملات) ارزش دارایی دیجیتال شما به شکل هوشمندانه‌ای افزایش پیدا می‌کند. در شرایطی که بازارهای جهانی طلا و نقره دچار نوسان‌اند، زرینو با بهره‌گیری از چندین شاخص پایدار، ریسک‌های ناشی از افت قیمت را به حداقل می‌رساند. سرمایه‌گذاری در زرینو، یک انتخاب هوشمندانه‌ است: ✅ امنیت دارایی دیجیتال ✅ نقدشوندگی بالا ✅ رشد چندجانبه ارزش ✅ مشارکت در توسعه طلایی شو پلتفرم فلزات گرانبها همین امروز زرینو بخرید و آینده مالی خود را هوشمندانه بسازید!" } },{ "@type": "Question", "name": "آیا قیمت طلا و نقره  در بازار طلایی  شو کمتر از سایر فروشندگان است؟", "acceptedAnswer": { "@type": "Answer", "text": "بله، به علت عرضه ی بالا و وجود بازار رقابتی در طلایی شو، قیمت طلا و نقره  پایین تر از سایر فروشندگان است." } },{ "@type": "Question", "name": "آیا سرمایه  گذاری در طلا و نقره  نیاز به یادگیری دارد؟", "acceptedAnswer": { "@type": "Answer", "text": "معامله و سرمایه   گذاری در طلا و نقره  بسیار راحت است. کافی است بخش راهنمای استفاده را بخوانید یا ویدیوی آموزشی را ببینید." } }]
            }
          `}
        </script>
      </Helmet>
      <Header />
      <div className="container mt-1">
        <div className="row justify-content-center">
          <div className="col-md-8 mt-2">
            <div>
              <div className="card-body">
                <h3 className="form-heading mb-4 text-center mt-3">
                  سوالات متداول
                </h3>
                {faqs.map((faq, index) => {
                  return (
                    <AccordionItem
                      key={index}
                      active={active}
                      handleToggle={handleToggle}
                      faq={faq}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faq;
